import { render, staticRenderFns } from "./jkgl.vue?vue&type=template&id=f0fa381e&scoped=true&"
import script from "./jkgl.vue?vue&type=script&lang=js&"
export * from "./jkgl.vue?vue&type=script&lang=js&"
import style0 from "./jkgl.vue?vue&type=style&index=0&id=f0fa381e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fa381e",
  null
  
)

export default component.exports